import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {OnePaneLayoutFullWidthSection} from '@udemy/react-layout-components';
import {Skeleton} from '@udemy/react-reveal-components';

import styles from './consolidated-hero-banner.module.less';

export interface ConsolidatedHeroBannerSkeletonProps {
    className?: string;
}

/** Neutral placeholder shown while the hero banner requests are in flight. */
export const ConsolidatedHeroBannerSkeleton = ({
    className,
}: ConsolidatedHeroBannerSkeletonProps) => {
    const {gettext} = useI18n();
    return (
        <OnePaneLayoutFullWidthSection>
            <OnePaneLayoutFullWidthSection.Content
                className={classNames(styles['consolidated-hero-banner'], className)}
            >
                <Skeleton
                    className={styles['skeleton-card']}
                    role="status"
                    aria-label={gettext('Loading hero banner')}
                />
            </OnePaneLayoutFullWidthSection.Content>
        </OnePaneLayoutFullWidthSection>
    );
};
